if (!customElements.get('lc-load-more')) {
  customElements.define('lc-load-more', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      this.status = this.querySelector('[role="status"]');
      this.grid = this.closest('#ProductGridContainer')?.querySelector('#product-grid');
      this.autoPages = 0;
      if (!this.link || !this.grid || this.ready) return;
      this.ready = true;
      this.addEventListener('click', (event) => {
        if (!event.target.closest('a') || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.load();
      });
      if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && !navigator.connection?.saveData) {
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some(entry => entry.isIntersecting) && this.autoPages < 2) this.load(true);
        }, { rootMargin: '250px 0px' });
        this.observer.observe(this.querySelector('.lc-load-sentinel'));
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }

    async load(automatic = false) {
      if (this.busy || !this.link || !this.isConnected) return;
      this.busy = true;
      this.controller = new AbortController();
      this.link.setAttribute('aria-disabled', 'true');
      this.grid.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loading;
      const url = new URL(this.link.href, location.href);
      url.searchParams.set('section_id', this.dataset.section);
      try {
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Unable to load collection');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = doc.querySelector('#product-grid');
        if (!incoming || !incoming.children.length) throw new Error('Missing product grid');
        if (!this.isConnected) return;
        const cards = [...incoming.children];
        cards.forEach(card => {
          card.classList.add('scroll-trigger--cancel');
          card.querySelectorAll('.scroll-trigger').forEach(node => node.classList.add('scroll-trigger--cancel'));
          this.grid.append(card);
        });
        const next = doc.querySelector('lc-load-more a');
        if (automatic) this.autoPages += 1;
        if (!automatic) {
          const focusTarget = cards[0].querySelector('a');
          focusTarget?.focus({ preventScroll: true });
        }
        if (next) {
          this.link.href = next.getAttribute('href');
          this.status.textContent = '';
        } else {
          this.link.remove();
          this.link = null;
          this.status.textContent = this.dataset.complete;
          this.observer?.disconnect();
        }
        if (this.autoPages >= 2) this.observer?.disconnect();
        window.Shopify?.PaymentButton?.init();
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) {
          this.status.textContent = this.dataset.error;
          this.observer?.disconnect();
        }
      } finally {
        this.busy = false;
        this.link?.removeAttribute('aria-disabled');
        this.grid?.removeAttribute('aria-busy');
      }
    }
  });
}
